import React, { useEffect, useState } from "react";
import { Container, Typography, Paper, Box, Button } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import VideoEmbed from './VideoEmbed';
import sessiondata from '../data/session.json';

const Coaching2 = ({ user }) => {
  const data = [
      { name: "Easy", Attempted: user.easy_tests_attempted, Passed: user.easy_tests_passed },
      { name: "Medium", Attempted: user.medium_tests_attempted, Passed: user.medium_tests_passed },
      { name: "Hard", Attempted: user.hard_tests_attempted, Passed: user.hard_tests_passed }
    ];

  const [feedback, setFeedback] = useState('Loading...');

  useEffect(() => {
      fetch('/data/session_feedback_script.txt')
	.then((res) => res.text())
	.then((text) => setFeedback(text))
	.catch(() => setFeedback('Failed to load feedback script.'));
    }, []);


  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Coaching
        </Typography>

        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            overflow: "hidden",
            borderRadius: 2,
            boxShadow: 2,
          }}
        >
	  <video
	    controls
	    className="w-full max-h-[500px] mb-6 rounded-lg shadow"
	  >
	    <source src="/videos/Coaching.mp4" type="video/mp4" />
	    Your browser does not support the video tag.
	  </video>

        </Box>
      </Paper>
      <br/>
      <div className="container mt-4">
	<h2>EasyMediumHard</h2>
      <br/>
	<ResponsiveContainer width="100%" height={300}>
	  <BarChart data={data}>
	    <CartesianGrid strokeDasharray="3 3" />
	    <XAxis dataKey="name" />
	    <YAxis allowDecimals={false} />
	    <Tooltip />
	    <Legend />
	    <Bar dataKey="Attempted" fill="#8884d8" />
	    <Bar dataKey="Passed" fill="#82ca9d" />
	  </BarChart>
	</ResponsiveContainer>
      </div>
    <div className="p-4">
	  <br/>
	<h2 className="text-2xl font-bold mb-4">Session Quality Scores</h2>
	<ResponsiveContainer width="100%" height={400}>
	  <BarChart data={sessiondata.sessions} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
	    <XAxis dataKey="name" angle={-45} textAnchor="end" interval={0} height={80} />
	    <YAxis domain={[0, 10]} />
	    <Tooltip />
	    <Legend />
	    <Bar dataKey="empathy" fill="#8884d8" />
	    <Bar dataKey="patience" fill="#82ca9d" />
	    <Bar dataKey="responsiveness" fill="#ffc658" />
	    <Bar dataKey="compliance" fill="#ff7f50" />
	  </BarChart>
	</ResponsiveContainer>
      </div>
    <br />
    <div className="p-6 max-w-4xl mx-auto">
    <br/>
	<h1 className="text-3xl font-bold mb-4">Session Feedback Script</h1>
	<div className="bg-white shadow-md rounded-lg overflow-hidden">
	  <div className="h-[600px] w-full overflow-y-auto p-4 space-y-4">
	    <pre className="whitespace-pre-wrap text-base leading-relaxed">{feedback}</pre>
	  </div>
	</div>
      </div>
    </Container>
  );
};

export default Coaching2;
